<template>
	<div class="product">
		<HNB></HNB>
		<poster></poster>
		<div class="product-nav2" ref="nav">
			<div class="product-ul2" v-for="(item,i) in list" :key='i' @click="choosemode(item.flag)">
				<span :class="{'active':item.flag==modeindex}">{{item.title}}</span>
				<div class="line2" v-if="i<(list.length-1)">|</div>
			</div>
		</div>
		<div class="product-center" v-for="(item,i) in listData" >
		<!-- <div class="product-center" v-for="(item,i) in listData" v-show="item.condition== getCondition(modeindex)"> -->
			<!-- {{item}} -->
			<div class="imgup" style="position: relative;">
				<div style="position: absolute; left: 10px; top: 10px;">
					<!-- <svgIcon :svg-name='item.svgName' size="40"></svgIcon> -->
				</div>
				<img @click="tocpz(item.active_name)" :src="item.product_use_img" style="width: 100%;">

			</div>
			<div class="boxshell">
				<div class="box-left">
					<div class="product-center-title">{{item.product_name}}</div>
					<div class="product-center-write" v-html="getFeatureStr(item.feature)"></div>
					<div class="product-center-know" @click="tocpz(item.active_name)">进一步了解></div>
				</div>
				<div class="box-right" @click="tocpz(item.active_name)"><img :src="item.rightImg" style="width: 100%;"></div>
			</div>

		</div>
		<bottom :BsTitle="bsTitle"></bottom>
	</div>

</template>

<script>
	import HNB from '../components/HeaderNavigationBar.vue'
	import bottom from '../components/Bottom.vue'
	import poster from '../components/Posters.vue'
	import svgIcon from '../components/SvgIcon.vue'
	import request from '../common/request.js'
	// import axios from 'axios'

	export default {
		name: 'product',
		data() {
			return {
				modeindex: 'life',
				condition: 1,
				bsTitle: ['首页', '产品介绍'],
				list: [{
						title: '生活更舒适',
						flag: 'life'
					}, {
						title: '出行更轻松',
						flag: 'walk'
					}, {
						title: '办公新姿势',
						flag: 'work'
					},


				],
				listData: [
					// {
					// 	leftImg: this.GLOBAL.imgHost + '/images/product/kaobei1.png',
					// 	rightImg: this.GLOBAL.imgHost + '/images/product/kaobei2.png',
					// 	infoTitle: '乐班人体工学可调靠背',
					// 	svgName: 'IF',
					// 	infoDetail: "环抱式承托｜一键升降<br>扭簧设计｜久坐不累",
					// 	activename: 'kaobei',
					// 	name: 'office'
					// },
				]

			}
		},
		mounted() {
			// this.listDate();
			this.getProductIntroList()
			this.modeindex = this.$route.query.bottomname || 'life';

			window.addEventListener('scroll', this.getScroll);
			//初次加载  回到顶部
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
			if (scrollTop > 0) {
				document.documentElement.scrollTop = 0;
			}
			if (this.$route.query.bottomname) {
				document.documentElement.scrollTop = this.$refs.nav.offsetTop;
			}
		},
		destroyed() {
			window.removeEventListener('scroll', this.getScroll);
		},
		computed:  {
			getFeatureStr() {
				return function(featureArr) {
					let featureStr = ''
					featureArr.forEach((item,index) => {
						if ((index + 1) % 2 == 0) {
							featureStr += item + '</br>'
						} 
						else if (index == featureArr.length-1) {
							featureStr += item + ''
						}
						else {
							featureStr += item + '|'
						}
					})
					return featureStr
				}
			}
		},

		methods: {
			tocpz(e) {
				let routeUrl = this.$router.resolve({
					path: "/Productstation",
					query: {
						cpzname: e
					}
				});
				window.open(routeUrl.href, '_self');
			},
			choosemode(e) {
				console.log("e", e)
				let that = this
				that.modeindex = e
				this.getCondition()
				this.getProductIntroList()
			},
			htmlEscape(str) {
				var temp = "";
				if (str.length == 0) return "";
				temp = str.replace(/&amp;/g, "&");
				temp = temp.replace(/&lt;/g, "<");
				temp = temp.replace(/&gt;/g, ">");
				temp = temp.replace(/&nbsp;/g, " ");
				temp = temp.replace(/&#39;/g, "\'");
				temp = temp.replace(/&quot;/g, "\"");
				return temp;
			},
			getCondition() {
				switch(this.modeindex) {
					case 'life': 
						this.condition = 1
						break;
					case 'walk':
						this.condition = 2
						break;
					case 'work':
						this.condition = 3
						break;
					default:
						this.condition = 1
						break
				}
			},
			// 获取产品列表
			async getProductIntroList() {
				// let condition
				
				// 获取数据
				// request.uniRequest('/product/getProductIntroByCon',{
				// 	params: {
				// 		condition: this.condition
				// 	}
				// })
				// 	.then(res => {
				// 		this.listData = res.data
				// 		console.log('test---product',this.listData);
				// 	}).catch(e => {})
				
				let res = await this.$Cloud.table(`lf_func_lefan_product`).where({condition: this.condition}).get({
					page: 0,
					pageSize: 1000
				})
				
				console.log('获取商品列表====>>>>>>', res)
				
				const {
					code,
					data
				} = res
				if (code == 200) {
					this.listData = data.filter(item => item.is_check == 2)
				}
				
			},
			// listDate() {
			// 	let that = this;
			// 	console.log('hahah');
			// 	let project_name = "web";
			// 	let type = 'CPJS';
			// 	let data = {
			// 		"project_name": project_name,
			// 		"type": type,
			// 	}
			// 	let requests = request.getQueryData(data || {})
			// 	that.$axios.post('/api_app/v2/mall/configinfo', // 还可以直接把参数拼接在url后边
			// 		requests).then(function(data) {
			// 		if (data.data.ResultCode == 200) {
			// 			for (let itme of data.data.data) {
			// 				console.log(itme.infoDetail)
			// 				let info = that.htmlEscape(itme.infoDetail);
			// 				console.log(info)
			// 				let poster = {
			// 					leftImg: itme.MainImg.url,
			// 					rightImg: itme.ViceImg.url,
			// 					infoTitle: itme.infoTitle,
			// 					svgName: itme.svgName == '0' ? '' : itme.svgName,
			// 					infoDetail: that.htmlEscape(itme.infoDetail),
			// 					activename: itme.activeName,
			// 					name: itme.name,
			// 				}
			// 				that.listData.push(poster);
			// 			}
			// 		}


			// 	}).catch(function(err) {});
			// },
		},
		components: {
			HNB,
			bottom,
			poster,
			svgIcon

		}
	}
</script>

<style>
	.product {
		max-width: 33.75rem;
		margin: 0 auto;

	}

	.product-nav2 {
		display: flex;
		justify-content: space-around;
		width: 85%;
		margin: 0 auto;
	}

	.product-nav2 .product-ul2 {
		/* border: 1px solid red; */
		display: flex;
	}

	.product-nav2 .product-ul2 span {
		font-size: 0.9rem;
		font-size: 0.85rem;
		font-family: Alibaba PuHuiTi;
		font-weight: 550;
		color: rgba(24, 24, 24, 1);
		opacity: 0.7;
		line-height: 2.375rem;
	}

	.product-nav2 .product-ul2 span.active {
		border-bottom: #00C785 2px solid;
		font-family: Alibaba PuHuiTi;
		opacity: 1;
	}

	.product-nav2 .line2 {
		width: 0.0625rem;
		height: 0.8rem;
		font-weight: 100;
		color: rgba(204, 204, 204, 1);
		margin: 0.9rem 0rem 1rem 1rem;
	}

	.product-center {
		padding-top: 3.125rem;
	}

	.product-center .imgup {
		width: 90%;
		margin: 0 auto;
	}

	.product-center .boxshell {
		width: 90%;
		display: flex;
		margin: 0 auto;
	}

	.product-center .boxshell .box-left {
		width: 68%;
	}

	.product-center .boxshell .box-left .product-center-title {
		font-size: 1.05rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 650;
		color: rgba(24, 24, 24, 1);
		text-align: left;
		line-height: 2.8125rem;
	}

	.product-center .boxshell .box-left .product-center-write {
		/* width:80%; */
		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-R;
		font-weight: 400;
		color: rgba(24, 24, 24, 1);
		opacity: 0.7;
		text-align: left;
	}

	.product-center .boxshell .box-left .product-center-know {
		font-size: 0.8rem;
		font-family: Alibaba-PuHuiTi-M;
		font-weight: 600;
		color: rgba(0, 199, 133, 1);
		text-align: left;
		line-height: 3rem;
	}

	.product-center .boxshell .box-right {
		margin-top: 5%;
		/* bottom: 10px; */
		width: 30%;
		max-width: 7.125rem;
	}
</style>
